import { render, staticRenderFns } from "./DisableAccNotification.vue?vue&type=template&id=7666ef4e&scoped=true"
import script from "./DisableAccNotification.vue?vue&type=script&lang=js"
export * from "./DisableAccNotification.vue?vue&type=script&lang=js"
import style0 from "./DisableAccNotification.vue?vue&type=style&index=0&id=7666ef4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7666ef4e",
  null
  
)

export default component.exports